/* eslint-disable camelcase */
import { getFilesizeLabel } from '../../utilities/file';
import PropTypes from 'prop-types';
import React from 'react';

const FileDownload = ({ display_name, extension, file, filename, filesize }) => {
    return (
        <section className="content-block || file-download-block || constrain-width">
            <div className="file-attachment">
                <div className="information">
                    <p className="filename">{display_name || filename}</p>
                    <p className="filesize">{`${getFilesizeLabel(filesize)} ${extension.toUpperCase()} file`}</p>
                </div>
                <a className="primary button inverse" href={file} download={filename} target="_blank" rel="noreferrer">Download</a>
            </div>
        </section>
    );
};

FileDownload.propTypes = {
    display_name: PropTypes.string,
    extension: PropTypes.string.isRequired,
    file: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    filesize: PropTypes.string.isRequired
};

export default FileDownload;
